import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function useUrlLocation() {
  const location = useLocation();
  const [path, setPath] = useState<string>(location.pathname.replace(/\//, '') || '');
  useEffect(() => {
    const currentPath = location.pathname.replace(/\//, '');
    setPath(currentPath);
  }, [location]);

  return path;
}
